export enum LiveEventTagGroup {
  DEFINING_OCCURRENCES = '663a2623981c6429cbdb520a',
}

export const hiddenLiveEventTagGroups: string[] = [LiveEventTagGroup.DEFINING_OCCURRENCES]
